import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {SlickCarouselModule} from "ngx-slick-carousel";
import { HeaderComponent } from './core/components/header/header.component';
import {SharedModule} from "./core/shared.module";
import { HttpClientModule } from '@angular/common/http';
// import {StickyNavModule} from "ng2-sticky-nav/dist";

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SlickCarouselModule,
    HttpClientModule,
    // StickyNavModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
